import { render } from "./PackCardModal.vue?vue&type=template&id=8bda2556"
import script from "./PackCardModal.vue?vue&type=script&lang=js"
export * from "./PackCardModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__